import { auth } from "../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import Modal from "react-bootstrap/Modal";
import logo from '../images/poetica-westfalia.png';
import aufbrueche from "../images/aufbrueche_Logo_final.png";
import img_map from "../images/img_map.png";
import info from "../images/info_blau.svg";
import Newsletter from '../components/Newsletter';
import { useState, useEffect } from "react";

export default function Home() {

  const [userState, setuserState] = useState(false);
  const [showInfo, setInfo] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        setuserState(true)
      }
      else {
        setuserState(false)
      }
    })
  })

  return (
    <div className="page-class">
      <img src={logo} alt="logo" className='img-fluid' />
      <p className="signifier">Eine lyrische Spurensuche für alle in Westfalen: Fahndet in Stadt und Land nach Gedichten, Lyrik, Versen und Worten. Meldet sie bis 1. Mai unserer Sammelstelle, die daraus eine poetische Landkarte Westfalens macht!</p>
      {userState ? <a href='/post' className='btn btn-primary mb-5 mt-3'>Direkt Poem melden</a> : <div className="mb-5 mt-3"><a href='/login' className='btn btn-primary'>Direkt zum Login</a><img src={info} className="info-icon" alt="" onClick={() => setInfo(true)} /></div>}
      <Modal show={showInfo} onHide={() => setInfo(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>Eine Anmeldung mit E-Mail und Passwort ist nötig, um unsere App vor unerlaubtem Zugriff zu schützen. Deine Daten werden verschlüsselt gespeichert und nicht an Dritte weitergegeben.
        </Modal.Body>
      </Modal>
      <h2>Dabei sein und mitmachen</h2>
      <p>
        Wo ist die Poesie heute? Gibt es sie noch, als lebendiger Teil unserer Kultur? Hat sie geheime Orte in der Stadt oder auf dem Land, Biotope, in denen sie überdauert oder gar neu gedeiht? Birgt Westfalen vielleicht einen noch nicht gehobenen poetischen Schatz an öffentlichen Orten? Und was ist für die heutige Bevölkerung eigentlich Lyrik?
      </p>
      <p>
        Wir wollen das herausfinden und die Poesie Westfalens dokumentieren. Unser Motto lautet: Dabeisein und mitmachen! Etwas zeitgeistiger ausgedrückt: Unser Projekt ist inklusiv und partizipativ. Wir wollen Kunst im Allgemeinen und Poesie im Besonderen in die Breite tragen, sie durchlässiger machen. Auch den Begriff davon erweitern, was überhaupt Literatur ist.
      </p>
      <p>
        Am Ende gibt es sowohl eine digitale wie gedruckte Landkarte mit allen Poesie-Standorten, die uns gemeldet wurden. Damit kann dann jeder seine individuelle poetischen Landpartie machen.
      </p>
      <p>Hier geht's zur aktuellen Karte:</p>
      <a href="/map"><img src={img_map} alt="Zur Karte" className="img-fluid w-100"/></a>
      
      <br/>
      <h3>Wir belohnen Ende Mai jeden Beitrag zum Faltplan mit einem kostenlosen Exemplar!</h3>
      <br/><br/><br/>
      <p>Du willst nichts verpassen? <br/>Abonniere unseren Newsletter:</p>

      <Newsletter />
      <br/><br/>
      <p>poetica westfalia ist Teil von</p>
      <img src={aufbrueche} alt="Aufbrüche" className='img-fluid w-75' />
    </div>
  )
}